<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-form ref="eventTypeAndVenueForm" onsubmit="return false;">
                <v-radio-group v-model="event_type" row>
                    <span class="mr-2 subheading">{{$t('screener.create.step.select_event_type.title')}} : </span>
                    <v-radio color="primary" :label="$t('screener.save.event_type.checkbox.label.virtual')" :value="DEFINES.SCREENER_TYPE.VIRTUAL"></v-radio>
                    <v-radio color="primary" :label="$t('screener.save.event_type.checkbox.label.physical')" :value="DEFINES.SCREENER_TYPE.PHYSICAL"></v-radio>
                    <v-radio color="primary" :label="$t('screener.save.event_type.checkbox.label.virtual_and_physical')" :value="DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL"></v-radio>
                </v-radio-group>
                <v-select
                    v-if="event_type >= DEFINES.SCREENER_TYPE.PHYSICAL"
                    :items="venues | published"
                    :rules="event_type>=DEFINES.SCREENER_TYPE.PHYSICAL?[rules.required, rules.min_length(1)]:[]"
                    v-model="physical_venue_id"
                    :label="'Select venue'"
                    outline
                    item-value="id"
                >
                <template v-slot:selection="{ item }">
                    <div>{{item.name}}</div>
                </template>
                <template v-slot:item="{ item }">
                    <div >
                        <div>{{item.name}}</div>
                        <div class="subheading greyDarken1--text">{{item.subtitle}}</div>
                    </div>
                </template>
                </v-select>
                <div v-if="event_type >= DEFINES.SCREENER_TYPE.PHYSICAL && !venues.length" class="py-2 subheading error--text">
                    {{$t('screener.create.step.select_event_type.warning')}}
                </div>
            </v-form>
        </v-flex>
        <v-flex xs12 class="text-xs-right mt-5">
            <v-btn class="ml-0" color="grey" outline @click.prevent="onCancel">{{
            $t("rms.button.cancel")
            }}</v-btn>
            <v-btn class="mr-0" color="primary" outline @click.prevent="onContinue">{{
            $t("rms.button.continue")
            }}</v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
import rules from "@/validation";

export default {
    name:"CreateScreenerAskEventType",
    props:{
        venues:{
            type:Array,
            default:function(){
                return [];
            }
        }
    },
    data(){
        return{
            rules,
            event_type:this.DEFINES.SCREENER_TYPE.VIRTUAL,
            physical_venue_id:null
        }
    },
    watch:{
        event_type(){
            this.$emit('update:event_type',this.event_type);
        },
        physical_venue_id(){
            this.$emit('update:physical_venue_id',this.physical_venue_id);
        }
    },
    methods:{
        onContinue(){
            if(!this.$refs.eventTypeAndVenueForm.validate()){
                return false;
            }
            this.$emit("onContinue",2);
        },
        onCancel(){
            this.event_type = this.DEFINES.SCREENER_TYPE.VIRTUAL;
            this.physical_venue_id = null;
            this.$emit('onCancel');
        }
    }
}
</script>

<style>

</style>
